import URLSearchParams from '@ungap/url-search-params';
import { sanitizeUrl } from '@braintree/sanitize-url';

export function getQueryParamValue(name: string): string | null {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return urlSearchParams.get(name);
}

export function getQueryParamValueOrCry(name: string): string {
  const queryParamValue = getQueryParamValue(name);

  if (!queryParamValue) {
    throw new Error(`URL query param "${name}" not found`);
  }
  return sanitizeUrl(queryParamValue);
}
